import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { App } from './components/App'
import { BroadcastOutput } from './components/BroadcastOutput'
import { LandingPage } from './components/landing/LandingPage'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<App />} />
        <Route path="/app/library" element={<App />} />
        <Route path="/broadcast/:token" element={<BroadcastOutput />} />
        <Route path="/broadcast" element={<App />} />
        <Route path="/app/broadcast" element={<App />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
